






































































// require('./lib/ui/root.js');

import router from "./router";
import errorPrompt from "./components/errorPrompt.vue";
import Navigation from "./components/nav.vue";
import Header from "./components/header.vue";
import globalLoad from "./components/globalLoad.vue";
import sideBar from "./components/sideBar.vue";
import itemPrompt from "./components/itemPrompt.vue";
import inlineTextEdit from "./components/inlineTextEdit.vue";
import {CalendarStructure} from "./components/calendar.vue";

import {frontendClient} from "./lib/client";

import {nextTick} from "process";

import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({
    components : {
        globalLoad,
        Navigation,
        Header,
        inlineTextEdit,
        itemPrompt,
        errorPrompt,
        sideBar
    },
})
export default class Extranet extends Vue{
    loggedIn:boolean = false;
    perc: number = 0;
    calDirection:number = 0;
    calStates:CalendarStructure = null;
    newDate:Date=null;
    navOpen:boolean=false;
    isPopupOpen:boolean = false;
    staffAllocated:number = 0;

    newJob:boolean=false;
    newAlert:boolean=false;
    newWalker:boolean=false;
    passwordUpdate:boolean=false;

    editObject:any=false;

    scopes = {
        home:true,
        calendar:false,
        jobs:false,
    }

    updaterFn: any;
    mounted(){
        this.updaterFn = this.updateLoggedIn.bind(this);
        frontendClient.on("userInfoUpdated",this.updaterFn);
        this.initiateFakeLoad();   
    }

    beforeDestroy() {
        frontendClient.removeListener("userInfoUpdated",this.updaterFn);
    }

    allocatedStaff(){
        this.staffAllocated = this.staffAllocated+1;
    }

    updateLoggedIn(){
        this.loggedIn = frontendClient.userData.isLoggedIn;

        if(!this.loggedIn && window.location.pathname != '/'){
            window.location.assign("/")
        }
    }

    popupOpen(){
        this.isPopupOpen = true;
    }
    popupClosed(){
        this.isPopupOpen = false;
    }

    openNav(){
        this.navOpen = true;
    }
    closeNav(){
        this.navOpen = false;
        this.isPopupOpen = false;
    }

    initiateNew(instance){
        this.editObject = null;
        this.closePrompts();
        switch(instance){
            case 'job':
                this.newJob = true;
                break;
            case 'alert':
                this.newAlert = true;
                break;
            case 'walker':
                this.newWalker = true;
                break;
        }
    }
    initiateEdit({instance,object}){
        this.editObject = null;
        this.editObject = object;
        this.closePrompts();
        switch(instance){
            case 'job':
                this.newJob = true;
                break;
            case 'alert':
                this.newAlert = true;
                break;
            case 'walker':
                this.newWalker = true;
                break;
            case 'password':
                this.passwordUpdate = true;
                break;
        }
    }
    closePrompts(){
        this.newJob = false;
        this.newWalker = false;
        this.newAlert = false;
        this.passwordUpdate = false;
    }

    catchCalUpdate(newCalObject){
        this.calStates = newCalObject;
    }

    initiateFakeLoad(){
        setInterval(()=>{
            let newPerc = this.perc + 30;
            this.updateLoad(newPerc);
        },600);
    }

    scope(x){
        this.scopes = {
            home:false,
            calendar:false,
            jobs:false,
        }

        switch(x){
            case 'home':
                this.scopes.home = true;
                break;
            case 'calendar':
                this.scopes.calendar = true;
                break
            case 'jobs':
                this.scopes.jobs = true;
                break;
            default:   
                this.scopes.home = true;
                break;
        }
    }

    updateLoad(newPerc){
        this.perc = newPerc;
    }

    updateCalendar(direction){
        // minus x = back x
        // plus x = forward x
        if(typeof direction == "object"){
            this.newDate = direction;
        }else{
            this.calDirection = direction;
            setTimeout(()=>{
                this.calDirection = 0;
            },50)
        }
        
        if(window["calendarFocusChanged"]) {
            window["calendarFocusChanged"]();
        }
    }
}
